// function tabbedToggles(element) {
//   var tabbedToggles_Container = element,
//     tabbedToggles_triggers =
//       tabbedToggles_Container.querySelectorAll(".toggle-trigger");

//   tabbedToggles_triggers.forEach((trigger, index) => {
//     trigger.addEventListener("click", function () {
//       this.classList.add("active");
//       let triggerClassNames = trigger.getAttribute("class").split(" ");
//       let triggerClassName = String(
//         triggerClassNames[
//           triggerClassNames.indexOf(
//             triggerClassNames.find((element) => element === "toggle-trigger")
//           ) + 1
//         ]
//       );
//       let tabbedToggles_Content = tabbedToggles_Container.querySelector(
//         ".toggle-content." + triggerClassName
//       );
//       tabbedToggles_Content.classList.add("active");
//       tabbedToggles_triggers.forEach((el) => {
//         if (el !== trigger) {
//           el.classList.remove("active");
//         }
//       });
//       tabbedToggles_Container
//         .querySelectorAll(".toggle-content")
//         .forEach((el) => {
//           if (el !== tabbedToggles_Content) {
//             el.classList.remove("active");
//           }
//         });
//     });
//   });
// }

// if (document.querySelector(".collection-set-toggles")) {
//   let sss = document.querySelectorAll(".collection-set-toggles");
//   sss.forEach((cst) => {
//     tabbedToggles(cst);
//   });
// }



function tabbedToggles(element) {
  var tabbedToggles_Container = element,
    tabbedToggles_triggers =
      tabbedToggles_Container.querySelectorAll(".toggle-trigger");

  tabbedToggles_triggers.forEach((trigger, index) => {
    trigger.addEventListener("click", function () {
      let triggerClassNames = trigger.getAttribute("class").split(" ");
      let triggerClassName = String(
        triggerClassNames[
          triggerClassNames.indexOf(
            triggerClassNames.find((element) => element === "toggle-trigger")
          ) + 1
        ]
      );
      let tabbedToggles_Content = tabbedToggles_Container.querySelector(
        ".toggle-content." + triggerClassName
      );

      tabbedToggles_triggers.forEach((el) => {
        if (el === trigger) {
          el.classList.add("active");
        } else {
          el.classList.remove("active");
        }
      });

      tabbedToggles_Content.classList.add("active");
      tabbedToggles_Container
        .querySelectorAll(".toggle-content")
        .forEach((el) => {
          if (el !== tabbedToggles_Content) {
            el.classList.remove("active");
          }
        });
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  let tabbedContainers = document.querySelectorAll(".multiple-collections-tab-container");
  tabbedContainers.forEach((container) => {
    tabbedToggles(container);
  });
});



if (document.querySelector("li[filter-name]")) {
  const filterables = (function () {
    let filterValues = [],
      filterItems = document.querySelectorAll("li[filter-name]");
    filterItems.forEach(function (item) {
      let faqFilterName = item.getAttribute("filter-name");
      item.classList.add(faqFilterName.toLowerCase().replace(" ", "-"));
      if (!filterValues.includes(faqFilterName)) {
        filterValues.push(faqFilterName);
      }
    });
    console.log(filterValues);
  })();
}


const filterEnabledSections = document.querySelectorAll(".filters-enabled");

if (filterEnabledSections.length > 0) {
  filterEnabledSections.forEach((section) => {
    const filterItems = section.querySelectorAll("li[data-filter-name]");
    const filterValues = new Set();
    let firstFilter = null;

    filterItems.forEach((item) => {
      const faqFilterName = item.getAttribute("data-filter-name");
      item.classList.add(faqFilterName.toLowerCase().replace(/ /g, "-"));
      filterValues.add(faqFilterName);

      if (!firstFilter) {
        firstFilter = faqFilterName;
      }
    });

    const filterTitleContainer = section.querySelector(".filter-titles-container");

    filterValues.forEach((val, index) => {
      const button = document.createElement("div");
      button.setAttribute("data-filter", val);
      button.textContent = val;
      button.classList.add("filter-button", val.toLowerCase().replace(/ /g, "-"));
      
      if (val === firstFilter) {
        button.classList.add("is-active");
        filterItems.forEach((item) => {
          if (item.dataset.filterName === firstFilter) {
            item.style.display = "block";
            item.classList.add("is-active");
          } else {
            item.style.display = "none";
            item.classList.remove("is-active");
          }
        });
      }

      filterTitleContainer.appendChild(button);

      button.addEventListener("click", () => {
        const target = button.dataset.filter;
        
        filterItems.forEach((item) => {
          if (item.dataset.filterName === target) {
            item.style.display = "block";
            item.classList.add("is-active");
          } else {
            item.style.display = "none";
            item.classList.remove("is-active");
          }
        });

        filterTitleContainer.querySelectorAll(".filter-button").forEach((btn) => {
          if (btn === button) {
            btn.classList.add("is-active");
          } else {
            btn.classList.remove("is-active");
          }
        });
      });
    });
  });
}

